export default {
    'MANAGERS.ADD.FORM.TITLE': 'Ajouter un manager',
    'MANAGERS.EDIT.FORM.TITLE': 'Modifier un manager',
    'MANAGERS.DELETE.FORM.TITLE': 'SUPPRIMER UN MANAGER',
    'MANAGERS.DELETE.FORM.CONFIRM.TITLE': 'Supprimer un manager',
    'MANAGERS.DELETE.FORM.CONFIRM.SUB': 'Êtes-vous certain de vouloir supprimer ce manager ?',
};
